import React from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import CLabel from '../../../../Common/CLabel';
import { Col, Row } from 'react-bootstrap';


const DialogUsedCauseWarning = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_IsDialogOpen = false,
        inputParam_SetterIsDialogOpen = null,
        inputParam_SetterDialogClose = null,
    } = props;
    
    return (
        <Dialog
            hidden={!inputParam_IsDialogOpen}
            onDismiss={inputParam_SetterDialogClose}
            minWidth={740}
            maxWidth={1000}
            dialogContentProps={{
                type: DialogType.normal,
                title: t('data-lang-lbl-action'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            <Row>
                <Col xs={12} xl={12} className="mt-3">
                    <CLabel labelValue={ "Esta acción reemplazará las causas previamente seleccionadas y todas las acciones asociadas a ellas." } /><br/>
                    <CLabel labelValue={ "¿Desea continuar?" } />
                </Col>
            </Row>
            <DialogFooter>
                <PrimaryButton onClick={() => inputParam_SetterIsDialogOpen(true)} text={t('data-lang-lbl-yes')} />
                <DefaultButton onClick={() => inputParam_SetterIsDialogOpen(false)} text={t('data-lang-lbl-no')} />
            </DialogFooter>
        </Dialog>
    );
};

DialogUsedCauseWarning.propTypes = {
    inputParam_IsDialogOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsDialogOpen: PropTypes.func.isRequired,
    inputParam_SetterDialogClose: PropTypes.func.isRequired
};

export default DialogUsedCauseWarning;